var map = {
	"./Discover.png": "9d02",
	"./JCB.png": "be79",
	"./MasterCard.png": "11a7",
	"./Visa.png": "3175",
	"./americanexpress.png": "9d61",
	"./dinersclub.png": "348d",
	"./discover.png": "585b",
	"./jcb.png": "9f05",
	"./mastercard.png": "29f0",
	"./visa.png": "1d74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f8e9";